import { userService } from "../services";
import config from "../config/config";

export const RawDataAction = {
  fetchImeiList,
  fetchRawData,
};

async function fetchImeiList(showSnackbar) {
  try {
    let apiEndpoint = `${config.rawDataBaseUrl}${config.apiName.fetchImeiList}`;
    debugger;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchRawData(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.rawDataBaseUrl}${config.apiName.fetchRawData}`;
    debugger;
    let response = await userService.postPlain(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
